<template>
  <div class="">
    <input type="password"
      v-model="password"
      class="input-standard"
      :disabled="loading"
      v-on:keyup="validatePassword($event.target.value)"
      v-on:focus="showPasswordTooltip = true"
      v-on:blur="showPasswordTooltip = false"
      v-tooltip.right.notrigger="{
        html   : 'passwordTooltipContent', 
        class  : 'tooltip-bg-white',
        visible: showPasswordTooltip
      }" />

    <div id="passwordTooltipContent" class="p-2 text-sm">
      <div class="text-base text-gray-900">
        To ensure that your account is safe, your password must meet the following criteria.
      </div>

      <div class="mt-3 overflow-hidden">
        <div class="float-left">
          <template v-if="passwordValidation.length">
            <img src="/static/img/icons/icons8-verified_account_filled-green.png" style="width:20px;" />
          </template>
          <template v-else>
            <img src="/static/img/icons/icons8-xbox_x.png" style="width:20px;" />
          </template>
        </div>

        <div class="float-left text-black" style="margin:2px 0 0 5px;">
          Must be at least 8 characters long.
        </div>
      </div>

      <div class="mt-1 overflow-hidden">
        <div class="float-left">
          <template v-if="passwordValidation.lowercase">
            <img src="/static/img/icons/icons8-verified_account_filled-green.png" style="width:20px;" />
          </template>
          <template v-else>
            <img src="/static/img/icons/icons8-xbox_x.png" style="width:20px;" />
          </template>
        </div>

        <div class="float-left text-black" style="margin:2px 0 0 5px;">
          Must include at least 1 lowercase letter.
        </div>
      </div>

      <div class="mt-1 overflow-hidden">
        <div class="float-left">
          <template v-if="passwordValidation.uppercase">
            <img src="/static/img/icons/icons8-verified_account_filled-green.png" style="width:20px;" />
          </template>
          <template v-else>
            <img src="/static/img/icons/icons8-xbox_x.png" style="width:20px;" />
          </template>
        </div>

        <div class="float-left text-black" style="margin:2px 0 0 5px;">
          Must include at least 1 uppercase letter.
        </div>
      </div>

      <div class="mt-1 overflow-hidden">
        <div class="float-left">
          <template v-if="passwordValidation.number">
            <img src="/static/img/icons/icons8-verified_account_filled-green.png" style="width:20px;" />
          </template>
          <template v-else>
            <img src="/static/img/icons/icons8-xbox_x.png" style="width:20px;" />
          </template>
        </div>

        <div class="float-left text-black" style="margin:2px 0 0 5px;">
          Must include at least 1 number.
        </div>
      </div>

      <div class="mt-1 overflow-hidden">
        <div class="float-left">
          <template v-if="passwordValidation.symbol">
            <img src="/static/img/icons/icons8-verified_account_filled-green.png" style="width:20px;" />
          </template>
          <template v-else>
            <img src="/static/img/icons/icons8-xbox_x.png" style="width:20px;" />
          </template>
        </div>

        <div class="float-left text-black" style="margin:2px 0 0 5px;">
          Must include at least 1 special character .
        </div>
      </div>
      <!-- startwithletter'=>'start with a letter',
'includelowercase'=>'include a lowercase letter',
'includeuppercase'=>'include an uppercase letter',
'includenumber'=>'include a number',
'includespecial'=>'include a special character (!, @, #, $, %, ^, *, &, (, ), -, +, ?, .)',
'notincludeemail'=>'not contain your e-mail address',
'includeonly'=>'not include other special characters',
'passwordmatch'=>'must match the other password you have entered'] as $k=>$v) -->
    </div>
  </div>
</template>

<script>

  export default {

    props : {

      propertyKey : {
        type    : String,
        required: false
      },

      updatePassword : {
        type    : Function,
        required: false
      },

      tooltip : {
        type    : String,
        required: false
      },

      value : {
        type    : String,
        required: false
      },

    },

    data () {
      return {
        loading            : false,
        password           : this.value,
        confirmPassword    : null,
        submitting         : false,
        showPasswordTooltip: false,

        passwordValidation : {
          length   : false,
          lowercase: false,
          uppercase: false,
          number   : false,
          symbol   : false
        }
      }
    },

    methods : {
      // validate password
      validatePassword(password) {

        // does it have at least 1 number?
        this.passwordValidation.number = /(?=.*\d)/.test(password)

        // is it at least 8 characters long?
        this.passwordValidation.length = password.length > 7

        // does it have at least 1 lowercase?
        this.passwordValidation.lowercase = /(?=.*[a-z])/.test(password)

        // does it have at least 1 uppercase?
        this.passwordValidation.uppercase = /(?=.*[A-Z])/.test(password)

        // does it have at least 1 character?
        this.passwordValidation.symbol = /[-+_!@#$%^&*.,?]/.test(password)

        // sync with the parent
        if(this.passwordValidation.number && 
           this.passwordValidation.length &&
           this.passwordValidation.lowercase &&
           this.passwordValidation.uppercase &&
           this.passwordValidation.symbol) {
          this.updatePassword({
            key  : this.propertyKey,
            value: password
          })
        } else {
          this.updatePassword(null)
        }
      },
    }
  }
</script>